var imagesLoaded = require('imagesloaded');
$(document).ready(function () {
    var owlActivites = $('.owl-activites');
    var owlEvents = $('.owl-events');

    owlActivites.on('resize.owl.carousel', function (event) {
        $('.last-active-item').removeClass('last-active-item');
    });
    owlActivites.on('translate.owl.carousel', function (event) {
        $('.last-active-item').removeClass('last-active-item');
    });

    owlActivites.on('translated.owl.carousel', function (event) {
        $('.owl-events .owl-item.active').last().addClass('last-active-item');
        $('.owl-activites .owl-item.active').last().addClass('last-active-item');
    });
    owlActivites.on('resized.owl.carousel', function (event) {
        $('.owl-activites .owl-item.active').last().addClass('last-active-item');
        $('.event-slide-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });
        $('.activite-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });
    });
    owlEvents.on('resize.owl.carousel', function (event) {
        $('.last-active-item').removeClass('last-active-item');
    });
    owlEvents.on('translate.owl.carousel', function (event) {
        $('.last-active-item').removeClass('last-active-item');
    });

    owlEvents.on('translated.owl.carousel', function (event) {
        $('.owl-events .owl-item.active').last().addClass('last-active-item');
        $('.owl-activites .owl-item.active').last().addClass('last-active-item');
    });
    owlEvents.on('resized.owl.carousel', function (event) {
        $('.owl-events .owl-item.active').last().addClass('last-active-item');
        $('.event-slide-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });
        $('.activite-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });
    });






    owlActivites.owlCarousel({
        margin: 15,
        loop: true,
        nav: true,
        navContainer: "#carousel-navigation",
        autoplay: true,
        autoplayTimeout: 1200,
        responsive: {
            0: {
                items: 1.3
            },
            768: {
                items: 2.3
            },
            1000: {
                items: 3.3
            },
            1200: {
                items: 4.3
            }
        }
    });

    owlEvents.owlCarousel({
        margin: 15,
        loop: true,
        nav: false,
        navContainer: "#carousel-events-navigation",
        responsive: {
            0: {
                items: 1.3
            },
            768: {
                items: 2.3
            },
            1000: {
                items: 3.3
            },
            1200: {
                items: 4.3
            }
        }
    });

    imagesLoaded('.slider-wide', function () {
        $(".owl-slider").owlCarousel({
            slideSpeed: 800,
            responsiveClass:true,
            paginationSpeed: 400,
            pagination: true,
            autoplay: true,
            autoplayTimeout: 4000,
            loop: true,
            items: 1

        });
    });


    $('.last-active-item').removeClass('last-active-item');
    $('.owl-activites .owl-item.active').last().addClass('last-active-item');
    $('.owl-events .owl-item.active').last().addClass('last-active-item');
    $('.activite-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });
    $('.event-slide-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });

    $("#entreprise .clients .owl-carousel").owlCarousel({
        loop: true,
        margin: 10,
        items: 5,
        nav: true,
        slideBy: '3',
        responsive: {

            0: {
                items: 1
            },

            450: {
                items: 2
            },
            646: {
                items: 3
            },


            760: {
                items: 4
            },

            990: {
                items: 4
            },

            991: {
                items: 3
            },
            1540: {
                items: 4
            },
            1800: {
                items: 5
            }
        }
    });

    $('#activite-single .owl-carousel').owlCarousel({
        loop: true,
        margin: 15,

        nav: true,
        responsive: {

            0: {
                items: 1
            },
            767: {
                items: 1.1
            }
        }
    });
    $('#news-single .owl-carousel').owlCarousel({
        loop: true,
        margin: 15,

        nav: true,
        responsive: {

            0: {
                items: 1
            },
            767: {
                items: 1.1
            }
        }
    });

    $('#special-events .gallery .owl-carousel').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        responsive: {

            0: {
                items: 1
            },
            767: {
                items: 1.1
            }
        }


    });

    $('#terrains-slider .owl-carousel').owlCarousel({
        loop: true,
        margin: 15,

        nav: true,
        responsive: {

            0: {
                items: 1.1
            },
            767: {
                items: 3.1
            },
            1200: {
                items: 4.1
            }
        }
    });


});
$(window).resize(function () {
    $('.activite-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });
    $('.event-slide-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });
    $('.terrains-slider-item').each(function () { $(this).children('strong').width($(this).children('img').width()) });
});